/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Smit Bosamiya",
  title: "Hi all, I'm Smit",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and REST API with PHP, Laravel, JavaScript, Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink: "https://drive.google.com/file/d/1B8xJKDEP-KDKur0HK1XO2YxiAzd66RF-/view?usp=drivesdk", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/smtbos",
  linkedin: "https://www.linkedin.com/in/smtbos",
  gmail: "smtbos@gmail.com",
  gitlab: "https://gitlab.com/smtbos",
  facebook: "https://www.facebook.com/smit.bosamiya",
  medium: "https://medium.com/@smtbos",
  stackoverflow: "https://stackoverflow.com/users/11853086/smit-bosamiya",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    // {
    //   skillName: "sass",
    //   fontAwesomeClassname: "fab fa-sass"
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    // {
    //   skillName: "reactjs",
    //   fontAwesomeClassname: "fab fa-react"
    // },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    // {
    //   skillName: "swift",
    //   fontAwesomeClassname: "fab fa-swift"
    // },
    // {
    //   skillName: "npm",
    //   fontAwesomeClassname: "fab fa-npm"
    // },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    // {
    //   skillName: "firebase",
    //   fontAwesomeClassname: "fas fa-fire"
    // },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Parul University",
      logo: require("./assets/images/parulLogo.png"),
      subHeader: "Master of Computer Applications",
      duration: "July 2021 - April 2023"
    },
    {
      schoolName: "Saurashtra University",
      logo: require("./assets/images/saurashtraLogo.jpeg"),
      subHeader: "Bachelor of Computer Applications",
      duration: "July 2018 - April 2021"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Programming",
      progressPercentage: "65%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "30%" //Insert relative proficiency in percentage
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Developer",
      company: "Coder Scotch Technologies",
      companylogo: require("./assets/images/coderscotchtechnologiesLogo.png"),
      date: "June 2024 – Present",
      desc: "Skilled in developing scalable applications with PHP, Laravel, MySQL, and Python, integrating advanced tools, secure authentication, and optimizing workflows for robust performance.",
    },
    {
      role: "Software Developer",
      company: "The Web Patriot",
      companylogo: require("./assets/images/thewebpatriotLogo.png"),
      date: "Jul 2023 – May 2024",
      desc: "Tech-savvy professional adept in PHP, Laravel, JavaScript, TypeScript, Node.js, Ruby, Vue.js, Docker, and CI/CD. Achieved notable milestones, including Chatwoot customization, Laravel API development, and multimedia conversation innovation in Node.js + TS.",
      descBullets: ["Employee of the month award winner", "Quick Learner"]
    },
    {
      role: "Software Trainee",
      company: "Wappnet Systems",
      companylogo: require("./assets/images/wappnetLogo.jpg"),
      date: "Nov 2022 – May 2023",
      desc: "Mastered PHP, Laravel, MySQL, PostgreSQL, and CI/CD, deepening expertise in the Laravel framework and gaining proficiency in CI/CD and deployment. Successfully implemented Spatie roles, custom roles and permission features, and complex relationships in Laravel projects."
    },
    {
      role: "Full Stack Developer",
      company: "Self Employed",
      companylogo: require("./assets/images/selfLogo.png"),
      date: "Apt 2019 – Nov 2022",
      desc: "Versatile professional adept in PHP, Laravel, JS, TS, Node, Python, MySQL, PostgreSQL, Docker, CI/CD, Selenium, GCP, VM, AWS, MongoDB, Android Java, HTML, CSS, jQuery, Bootstrap, with proven skills in client communication, project implementation, payment gateway integration, referral systems, bonus structures, wallet management, and comprehensive testing."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// TODO: Add Projects Here
// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/lessonflixLogo.png"),
      projectName: "Lessonflix",
      projectDesc: "Streamline lesson management and effortlessly track completion status with our dedicated platform designed for schools.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://lessonflix.smtbos.com"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/studentsCrudLogo.png"),
      projectName: "Students CRUD",
      projectDesc: "A simple CRUD application for students to manage their details.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://mern-students-crud.smtbos.com"
        },
        {
          name: "Github FE",
          url: "https://github.com/smtbos/mern-students-crud-fe"
        },
        {
          name: "Github BE",
          url: "https://github.com/smtbos/mern-students-crud-be"
        }
      ]
    },
    {
      image: require("./assets/images/productsCrudLogo.png"),
      projectName: "Products CRUD",
      projectDesc: "A simple CRUD application for products to manage their details.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://laravel-webpatriot-practical.smtbos.com"
        },
        {
          name: "Github",
          url: "https://github.com/smtbos/laravel-webpatriot-practical"
        }
      ]
    },
    {
      image: require("./assets/images/indiahealthLogo.png"),
      projectName: "India health",
      projectDesc: "The Laboratory Management System Provide Facility to All Laboratories to Make and Save their Reports",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://indiahealth.smtbos.com"
        },
        {
          name: "Github",
          url: "https://github.com/smtbos/indiahealth"
        }
      ]
    },
    {
      image: require("./assets/images/IMSLogo.png"),
      projectName: "Inventory Management System",
      projectDesc: "This is a simple stock management system built with the Laravel. It allows you to manage products and lot wise stock.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://bacancy.smtbos.com"
        },
        {
          name: "Github",
          url: "https://github.com/smtbos/laravel-bacancy-practical"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Certificate of Excellence",
      image: require("./assets/images/certificateLogo.png"),
      imageAlt: "Certificate Logo",
      footerLink: [
        {
          name: "Certification",
          url: "./files/certificate-of-excellence.pdf"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  // subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-8128389164",
  email_address: "smtbos@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
